"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * a utiliser par exemple : myArray.sort(sortUtils.alphanumCompartorBuilder('label')); Vous pouvez utiliser des propriété composées (x.y.label)
 */
ngModule.factory("sortUtils", function (objectUtils) {
  var buildPropertyGetter = function buildPropertyGetter(attr) {
    if (attr.split('.').length === 1) {
      return function (obj) {
        return obj[attr];
      };
    } else {
      return function (obj) {
        return objectUtils.getProperty(obj, attr);
      };
    }
  };
  var sortUtils = {
    stringComparatorBuilder: function stringComparatorBuilder(attr) {
      var getProperty = buildPropertyGetter(attr);
      return function stringComparator(a, b) {
        var attrA = (getProperty(a) || "").toLowerCase();
        var attrB = (getProperty(b) || "").toLowerCase();
        return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
      };
    },
    /**
     * cf. http://web.archive.org/web/20130826203933/http://my.opera.com/GreyWyvern/blog/show.dml/1671288
     */
    alphanumCompartorBuilder: function alphanumCompartorBuilder(attr) {
      var getProperty = buildPropertyGetter(attr);
      return function alphanumComparator(a, b) {
        var attrA = (getProperty(a) || "").toLowerCase();
        var attrB = (getProperty(b) || "").toLowerCase();
        var aa = attrA.split(/(\d+)/);
        var bb = attrB.split(/(\d+)/);
        for (var x = 0; x < Math.max(aa.length, bb.length); x++) {
          if (aa[x] !== bb[x]) {
            var cmp1 = isNaN(parseInt(aa[x], 10)) ? aa[x] : parseInt(aa[x], 10);
            var cmp2 = isNaN(parseInt(bb[x], 10)) ? bb[x] : parseInt(bb[x], 10);
            if (cmp1 === undefined || cmp2 === undefined) {
              return aa.length - bb.length;
            } else {
              return cmp1 < cmp2 ? -1 : 1;
            }
          }
        }
        return 0;
      };
    },
    dateComparatorBuilder: function dateComparatorBuilder(attr) {
      var getProperty = buildPropertyGetter(attr);
      return function dateComparator(a, b) {
        var attrA = getProperty(a);
        var attrB = getProperty(b);
        if (attrA == null && attrB == null) return 0;
        if (attrA == null && attrB != null) return -1;
        if (attrB == null && attrA != null) return 1;
        return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
      };
    },
    montantComparatorBuilder: function montantComparatorBuilder(attr) {
      var getProperty = buildPropertyGetter(attr);
      return function montantComparator(a, b) {
        var attrA = getProperty(a);
        var attrB = getProperty(b);
        if (attrA == null && attrB == null) {
          return 0;
        } else if (attrA == null) {
          return -1;
        } else if (attrB == null) {
          return 1;
        } else {
          return attrA.valeur < attrB.valeur ? -1 : attrA.valeur > attrB.valeur ? 1 : 0;
        }
      };
    },
    booleanComparatorBuilder: function booleanComparatorBuilder(attr) {
      var getProperty = buildPropertyGetter(attr);
      return function booleanComparator(a, b) {
        var attrA = getProperty(a);
        var attrB = getProperty(b);
        return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
      };
    },
    numberComparatorBuilder: function numberComparatorBuilder(attr) {
      var getProperty = buildPropertyGetter(attr);
      return function numberComparator(a, b) {
        var attrA = getProperty(a);
        var attrB = getProperty(b);
        return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
      };
    }
  };
  return sortUtils;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/sortUtils.js
// module id = 2764
// module chunks = 13